<template>
	<div :id="`content-box-${id}`" class="content-box">
		<div class="container">
			<div class="content-box-content-wrapper">
				<div class="content-box-content">
					<h2 class="heading" v-if="content.title" v-html="sanitizeTitle(content.title)"></h2>
					<div v-if="content.text" class="content-box-text">
						<RichText :content="content.text.content" />
						<Button v-if="content?.cta" :data="content?.cta?.fields"/>
					</div>
				</div>
				<div v-if="content.specs" class="content-box-specs">
					<h2 class="heading" v-if="content.title" v-html="sanitizeTitle(content.title)"></h2>
					<RichText :content="content.specs.content" />
				</div>
			</div>
			<div class="content-box-image" :mask="content?.maskImage">
				<Image v-if="content.image" :image="content.image" />
				<svg class="no-image" v-else width="1600" height="712" viewBox="0 0 1600 712" fill="none" xmlns="http://www.w3.org/2000/svg">
					<rect width="1600" height="712" fill="#020202"/>
				</svg>

			</div>
		</div>
		<div class="content-box-angular-separator">
			<div class="content-box-angular-separator-image"></div>
		</div>
	</div>
</template>

<script setup>
import {useSanitize} from "~~/composables/useSanitize.js";
const { sanitizeTitle } = useSanitize();

const props = defineProps({
	content: {
		type: Object,
		required: true
	},
	id: {
		type: String,
		required: true
	}
});
</script>

<style lang="scss">
@use '~/assets/scss/components/ContentBox.scss';
</style>